import { Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { AuthService } from '../../../auth/services/auth.service';
import { IAppState } from '../../../store/interface/app.state.interface';
import { PermissionKey } from '../../../shared/enum/permission-key.enum';
import { PermissionLevel } from '../../../shared/enum/permission-level.enum';
import { getFullName } from '../../../shared/utils/string.util';
import { holdsPermission } from '../../../shared/utils/permission.util';
import { selectLoggedInUser } from '../../../store/user/user.selectors';

@Component({
    standalone: false,
    selector: 'app-business-exit',
    templateUrl: './business-exit.component.html',
})
export class BusinessExitComponent {
    private readonly authService = inject(AuthService);
    private readonly store = inject(Store<IAppState>);
    private readonly loggedInUser = this.store.selectSignal(selectLoggedInUser);

    protected readonly businessName = computed(() => this.loggedInUser()?.business.name ?? '');
    protected readonly message = computed(() => {
        const user = this.loggedInUser();
        if (!user) return '';
        if (!user.isStaff) return `You are in ${user.business.name}.`;

        const canAct = holdsPermission(
            user,
            PermissionKey.PLATFORM_BUSINESS_ACCESS,
            PermissionLevel.MANAGE,
        );
        return (
            `You are inside ${user.business.name} as ${getFullName(user.person)}, Triatech staff. ` +
            (canAct ? 'You can act as its Admin.' : 'You can look only.')
        );
    });

    protected exit(): void {
        void this.authService.exitToAccountApp();
    }
}
